// frontend/config/wsDirectRconConfig.js

export const WS_DIRECT_RCON_TYPES = {
    // Server -> Client (Status/Responses)
    STATUS_UPDATE: 'DIRECT_RCON_STATUS_UPDATE',
    CONNECTED: 'DIRECT_RCON_CONNECTED',
    CONNECTION_FAILED: 'DIRECT_RCON_CONNECTION_FAILED',
    AUTH_FAILED: 'DIRECT_RCON_AUTH_FAILED',
    NO_DETAILS: 'DIRECT_RCON_NO_DETAILS',
    COMMAND_RESPONSE: 'DIRECT_RCON_COMMAND_RESPONSE',
    DISCONNECTED: 'DIRECT_RCON_DISCONNECTED',

    // Client -> Server (Commands for the module)
    SEND_COMMAND: 'DIRECT_RCON_SEND_COMMAND', // This type is used in the payload for APP_SEND_COMMAND
    REQUEST_DISCONNECT: 'DIRECT_RCON_REQUEST_DISCONNECT', // This type is used in the payload for APP_REQUEST_DISCONNECT
};

export const WS_DIRECT_RCON_TOPICS = {
    // Destinations for Client Commands to the DirectRconController/Module
    APP_ENDPOINT_BASE: '/directrcon', // Corrected: Removed /app prefix, STOMP client handles it.
    APP_SEND_COMMAND: '/command', // Corrected: Suffix for the base endpoint.
    APP_REQUEST_DISCONNECT: '/disconnect', // Corrected: Suffix for the base endpoint.

    // User-Specific Subscription Topics (Backend -> Frontend for this module)
    USER_QUEUE_BASE: '/user/queue/directrcon', // Base for user-specific messages
    USER_STATUS_DESTINATION: '/status',   // For connection status, errors (e.g., /user/queue/directrcon/status)
    USER_RESPONSE_DESTINATION: '/response', // For command responses (e.g., /user/queue/directrcon/response)
};

// Helper to build full app destination path (e.g., /app/directrcon/command)
export const getDirectRconAppEndpoint = (action) => `${WS_DIRECT_RCON_TOPICS.APP_ENDPOINT_BASE}${action.startsWith('/') ? action : '/' + action}`;

// Helper to build full user queue topic path (e.g., /user/queue/directrcon/status)
export const getDirectRconUserQueueTopic = (subTopic) => `${WS_DIRECT_RCON_TOPICS.USER_QUEUE_BASE}${subTopic.startsWith('/') ? subTopic : '/' + subTopic}`;